import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { determineLocale, Person } from 'diwimamodelweb/lib';
import { Observable } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { PersonService } from 'src/app/shared/person.service';
import { SettingsService } from 'src/app/shared/settings.service';
import { UserFeedbackService } from 'src/app/shared/user-feedback.service';
import { environment } from 'src/environments/environment';
import { EventInviteSharedService } from '../event-invite-shared.service';

export async function fallbackCopyTextToClipboard(text): Promise<any> {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    document.body.removeChild(textArea);
    return null
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    document.body.removeChild(textArea);
    return err
  }
}
export async function copyTextToClipboard(text) {
  
  try {
    if (!navigator.clipboard) {
      await fallbackCopyTextToClipboard(text);
    } else {
      navigator.clipboard.writeText(text).then(function() {
        return null
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
        return err
      });
    }
    return 
  } catch (error) {
    return error 
  }
}


@Component({
  selector: 'app-mng-person',
  templateUrl: './mng-person.component.html',
  styleUrls: ['./mng-person.component.css', '../invitaion-dashboard/invitaion-dashboard.component.scss']
})
export class MngPersonComponent implements OnInit {

  person$: Observable<any>
  person: Person[]
  show = false
  sort: MatSort
  dataSource: MatTableDataSource<Person>
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  locale: string
  @ViewChild(MatSort) set matSort(m) {
    if (m) {
      setTimeout(() => {
        this.sort = m
        this.sort.sortChange.subscribe(() => this.dataSource.paginator.pageIndex = 0);
        if (this.dataSource) {
          this.dataSource.sort = this.sort
        }
      })
    }
  }
  paginatorPageSizeOptions = [5, 25, 50, 100]
  displayedColumns = ['anzeigeName', 
  'telefon', 'emailAddresse', "copy" 
  // 'options'
  ]
  // allInvitations$: Observable<any>

  personFilterForm: FormGroup


  constructor(
    private eventInviteSharedService: EventInviteSharedService,
    // private eventsService: EventsService,
    private personService: PersonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private userFeedbackService: UserFeedbackService,
    private translate: TranslateService
  ) {
    this.locale = determineLocale(navigator.language)
  }

  ngOnInit(): void {
    const selectedContext = this.settingsService.selectedUserContext$.value
    if (!selectedContext.huntingEventManagement) {
      this.router.navigate(['../', 'info'], {relativeTo: this.route})
    }
    this.personFilterForm = this.formBuilder.group({
      searchString: []
    })
    this.personFilterForm.valueChanges.subscribe((value) => {
      const {searchString} = value
      this.filterPerson(searchString)
    })
    this.person$ = this.personService.personSubject$.pipe(skipWhile(el => !el))
    this.person$.subscribe((person) => {
      this.person = person
      this.createTable(person)
    })
  }

  filterPerson(searchString: string|undefined) {
    if (!searchString || searchString == "") {
      this.createTable(this.personService.personSubject$.value)
      return 
    }
    let str = searchString
    if (searchString) str = searchString.toLowerCase()
    const filtered = this.personService.personSubject$.value.filter(el => el.searchFilter(str))
    this.createTable(filtered)
  }

  createTable(data: Person[]) {
    this.show = false
    this.dataSource = new MatTableDataSource(data)
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.show = true
  }

  editBasedOnPerson(person: Person) {
    this.router.navigate([person.identifier], {relativeTo: this.route})
  }

  navBack() {
    this.router.navigate(['..'], {relativeTo: this.route})
  }

  async getInvitationLink(element: Person) {
    try {
      await copyTextToClipboard(`${environment.invitationURL}/inv/${element.invitationRef}`) 
      const text = await this.translate.get('snack_success_copy').toPromise()
      this.userFeedbackService.showSnackBar.emit(text)
    } catch (error) {
      const text = await this.translate.get('snack_failure_copy').toPromise()
      this.userFeedbackService.showSnackBar.emit(text)
    }    
  }

}
